import cn from 'classnames';
import type { ReactNode } from 'react';

import { useCacheKey } from '@libs/common-next';

import css from './raw.module.scss';

interface Props {
    value: string;
    icon: ReactNode;
    onChange(value: string): void;
}
export function Raw({ value, icon, onChange }: Props) {
    const { key } = useCacheKey();

    return (
        <section className={css.wrapper}>
            <header className={css.header}>
                <span>{icon}</span>
                <div>
                    <p className={css.title}>Raw cache key</p>
                    <p className={css.subtitle}>Base64 encoded cache key.</p>
                </div>

                <span className={css.chip}>
                    <span className={cn(css.dot, { [css.modified]: key !== value })} />
                    {key === value ? 'Initial' : 'Modified'}
                </span>
            </header>

            <div className={css.key}>
                <textarea
                    value={value}
                    name="cache-key"
                    className={css.input}
                    onChange={e => onChange(e.target.value)}
                    autoComplete="off"
                />
            </div>
        </section>
    );
}
